const state = {
  showLoginModal: false,
  user: null,
};
const mutations = {
  changeShow(state, status) {
    state.showLoginModal = status;
  },
  setUserInfo(state, user) {
    state.user = user;
  },
};
const actions = {
  changeShow({ commit }, status) {
    commit('changeShow', status);
  },
  setUserInfo({ commit }, user) {
    commit('setUserInfo', user);
  },
};
export default {
  state,
  mutations,
  actions,
};
